export interface ComicItem {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: string;
  summary: string;
  note: string;
  cover: string;
}

export const editorPicks: ComicItem[] = [
  {
    id: "ep-1",
    title: "山海异闻录",
    author: "青禾",
    genre: "东方奇幻",
    tags: ["上古神话", "冒险", "群像"],
    rating: "9.2",
    summary:
      "一卷尘封的山海图录，引少年阿砚踏入百妖横行的上古世界。在神明与异兽的夹缝里，他逐步揭开封印千年的秘密。",
    note: "世界观扎实、画风壮阔，是本月编辑部全员二刷的东方冒险长篇。",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20comic%20book%20cover%20of%20a%20young%20hero%20in%20ancient%20Chinese%20armor%20surrounded%20by%20mythical%20beasts%20and%20clouds%2C%20vibrant%20ink%20wash%20painting%20style%20with%20warm%20crimson%20and%20teal%20tones%2C%20dramatic%20mountain%20landscape%20background%2C%20clean%20composition%2C%20high%20detail%20illustration&width=480&height=640&seq=cover-shanhai&orientation=portrait",
  },
  {
    id: "ep-2",
    title: "巷口便利店",
    author: "顾晚",
    genre: "都市日常",
    tags: ["治愈", "邻里", "单元剧"],
    rating: "9.0",
    summary:
      "深夜营业的巷口便利店，收留了每一个疲惫的灵魂。一盏灯、一碗关东煮，串起都市人的温暖碎片。",
    note: "细腻到骨子里的生活质感，看完会想给楼下便利店老板一个拥抱。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20comic%20cover%20of%20a%20small%20warm%20glowing%20convenience%20store%20at%20night%20in%20a%20quiet%20residential%20alley%2C%20soft%20yellow%20storefront%20light%2C%20gentle%20rain%20and%20neon%20reflection%2C%20warm%20pastel%20palette%2C%20heartwarming%20slice%20of%20life%20style%2C%20clean%20peaceful%20composition&width=480&height=640&seq=cover-bianli&orientation=portrait",
  },
  {
    id: "ep-3",
    title: "星轨漫游指南",
    author: "南栀",
    genre: "科幻浪漫",
    tags: ["太空", "治愈", "公路片"],
    rating: "8.9",
    summary:
      "一段横跨银河的漫游旅程，孤独的航天员与一台有情绪的旧飞船AI，在漫天星轨中寻找失落的答案。",
    note: "浪漫与科幻平衡得恰到好处，配乐一般的分镜让人舍不得快进。",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20anime%20comic%20cover%20of%20an%20astronaut%20floating%20in%20a%20nebulae%20filled%20galaxy%20with%20glowing%20star%20trails%2C%20soft%20lavender%20and%20warm%20amber%20nebula%20light%2C%20melancholic%20yet%20peaceful%20atmosphere%2C%20cinematic%20space%20illustration%2C%20clean%20composition&width=480&height=640&seq=cover-xinggui&orientation=portrait",
  },
  {
    id: "ep-4",
    title: "深夜食堂后厨",
    author: "程野",
    genre: "美食温情",
    tags: ["料理", "温情", "夜话"],
    rating: "9.1",
    summary:
      "每到午夜才开门的后厨，只做一份客人最想吃的菜。烟火气里，藏着每个人难以言说的心事。",
    note: "隔着屏幕都能闻到香气，每一道菜都讲一个让人眼眶发热的故事。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20anime%20comic%20cover%20of%20a%20cozy%20midnight%20kitchen%20counter%20with%20steaming%20hot%20ramen%20and%20fresh%20ingredients%2C%20soft%20warm%20lantern%20light%2C%20steam%20rising%2C%20cooking%20on%20a%20cast%20iron%20stove%2C%20heartwarming%20food%20story%20manga%20style%2C%20warm%20ochre%20and%20cream%20tones&width=480&height=640&seq=cover-shitang&orientation=portrait",
  },
];

export const dailyPicks: ComicItem[] = [
  {
    id: "dp-1",
    title: "花火集",
    author: "洛可可",
    genre: "青春校园",
    tags: ["夏日", "青春", "成长"],
    rating: "8.7",
    summary:
      "夏天结束前的最后一个烟花夜，五个少年各自许下不同的愿望。关于友情、初恋与告别的青春群像。",
    note: "今日份清爽：满屏都是十八岁的风与蝉鸣。",
    cover: "https://readdy.ai/api/search-image?query=Bright%20anime%20comic%20cover%20of%20a%20summer%20fireworks%20festival%20with%20school%20uniform%20students%20silhouettes%2C%20golden%20sunset%20sky%20and%20colorful%20fireworks%20bursts%2C%20youthful%20nostalgic%20atmosphere%2C%20warm%20orange%20and%20soft%20blue%20tones%2C%20clean%20cheerful%20composition&width=480&height=640&seq=cover-huahuo&orientation=portrait",
  },
  {
    id: "dp-2",
    title: "铁匠铺的女儿",
    author: "老刀",
    genre: "热血成长",
    tags: ["锻刀", "冒险", "立志"],
    rating: "8.8",
    summary:
      "父亲留下的铁匠铺里，少女小满决定锻造出那把传说中斩断命运之剑。锤声里，是她不肯低头的倔强。",
    note: "挥锤的每一格都铿锵有力，热血而不落俗套。",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20anime%20comic%20cover%20of%20a%20determined%20young%20blacksmith%20girl%20hammering%20a%20glowing%20sword%20in%20a%20fiery%20forge%2C%20sparks%20flying%2C%20warm%20ember%20and%20deep%20charcoal%20tones%2C%20epic%20manga%20style%2C%20high%20contrast%20lighting%2C%20clean%20dynamic%20composition&width=480&height=640&seq=cover-tiejiang&orientation=portrait",
  },
  {
    id: "dp-3",
    title: "雾城侦探",
    author: "墨白",
    genre: "悬疑推理",
    tags: ["探案", "迷雾", "单元剧"],
    rating: "8.9",
    summary:
      "终年笼罩在雾里的城市，每个清晨都会出现新的谜题。落魄侦探老许和他的新手助手，在雾中一步步逼近真相。",
    note: "反转环环相扣，读完忍不住回头再翻一遍线索。",
    cover: "https://readdy.ai/api/search-image?query=Noir%20anime%20comic%20cover%20of%20a%20trench%20coat%20detective%20holding%20a%20lantern%20in%20a%20foggy%20mysterious%20city%20street%20at%20night%2C%20dim%20amber%20streetlights%2C%20dense%20mist%20and%20tall%20shadowy%20buildings%2C%20suspenseful%20mood%2C%20muted%20teal%20and%20charcoal%20tones&width=480&height=640&seq=cover-wucheng&orientation=portrait",
  },
  {
    id: "dp-4",
    title: "云端邮差",
    author: "白鹭",
    genre: "奇幻治愈",
    tags: ["天空", "治愈", "信件"],
    rating: "8.6",
    summary:
      "住在云端之城的邮差少年，负责把寄往天空另一端的心愿准时送达。每一封信，都是一段温柔的重逢。",
    note: "画风轻盈得像羽毛，适合睡前慢慢读。",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20anime%20comic%20cover%20of%20a%20young%20postman%20flying%20over%20a%20city%20in%20the%20clouds%20with%20floating%20letter%20envelopes%20and%20soft%20morning%20light%2C%20light%20pastel%20sky%2C%20gentle%20magical%20atmosphere%2C%20dreamy%20illustration%2C%20soft%20cream%20and%20sky%20blue%20tones&width=480&height=640&seq=cover-yunduan&orientation=portrait",
  },
];

export const hiddenGems: ComicItem[] = [
  {
    id: "hg-1",
    title: "苔藓图书馆",
    author: "林晚声",
    genre: "冷门治愈",
    tags: ["植物", "静物", "哲学"],
    rating: "9.0",
    summary:
      "藏在旧街深处的图书馆，管理员会为每一位迷路的读者，用苔藓拼出他们心底最需要的那本书的名字。",
    note: "全年最低调的神作，编辑部私心强烈推荐的小众宝藏。",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20anime%20comic%20cover%20of%20a%20cozy%20old%20library%20interior%20covered%20in%20green%20moss%20with%20shelves%20of%20books%20and%20soft%20dusty%20sunlight%20through%20windows%2C%20calm%20moss%20green%20and%20cream%20palette%2C%20gentle%20meditative%20atmosphere%2C%20clean%20minimalist%20illustration&width=480&height=640&seq=cover-taixian&orientation=portrait",
  },
  {
    id: "hg-2",
    title: "纸鸢线",
    author: "苏萤",
    genre: "文艺成长",
    tags: ["小镇", "风筝", "友情"],
    rating: "8.8",
    summary:
      "南方小镇的雨季，两个因风筝结缘的少年，在长长短短的线里，笨拙地学着告别与再出发。",
    note: "笔触像散文，情绪像水墨，读后余韵悠长。",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20anime%20comic%20cover%20of%20a%20colorful%20paper%20kite%20flying%20over%20a%20small%20rainy%20southern%20chinese%20town%20with%20tiled%20roofs%20and%20lanterns%2C%20soft%20watercolor%20mood%2C%20rain%20drops%2C%20warm%20nostalgic%20and%20slightly%20melancholic%20tone%2C%20literary%20manga%20style&width=480&height=640&seq=cover-zhiyuan&orientation=portrait",
  },
  {
    id: "hg-3",
    title: "守门人",
    author: "方寸",
    genre: "哲理短篇",
    tags: ["寓言", "边界", "短篇集"],
    rating: "8.9",
    summary:
      "一道门，一方天地。十二个守门人的故事，叩问着人们为何执意要守住那些看似无用的边界。",
    note: "每篇都像一枚榫卯，严丝合缝地卡进心里。冷门却高级。",
    cover: "https://readdy.ai/api/search-image?query=Minimalist%20anime%20comic%20cover%20of%20an%20ancient%20giant%20stone%20door%20in%20a%20vast%20empty%20landscape%20with%20a%20tiny%20guardian%20figure%20standing%20before%20it%2C%20moody%20low%20light%2C%20philosophical%20and%20quiet%20atmosphere%2C%20muted%20earth%20tones%2C%20clean%20minimalist%20composition&width=480&height=640&seq=cover-shoumen&orientation=portrait",
  },
  {
    id: "hg-4",
    title: "盐与月光",
    author: "陶枝",
    genre: "冷门恋爱",
    tags: ["海边", "克制", "慢热"],
    rating: "8.7",
    summary:
      "海边小城的面包师与深夜值班的灯塔员，一段没有告白、却甜得刚刚好的慢热日常。",
    note: "盐分与月光调得刚好，喜欢细腻恋爱物语的不要错过。",
    cover: "https://readdy.ai/api/search-image?query=Soft%20anime%20comic%20cover%20of%20a%20bakery%20by%20the%20sea%20at%20night%20with%20moonlight%20reflecting%20on%20waves%20and%20a%20distant%20lighthouse%2C%20warm%20window%20light%20from%20the%20bakery%2C%20romantic%20and%20calm%20mood%2C%20soft%20blue%20and%20warm%20cream%20tones%2C%20clean%20composition&width=480&height=640&seq=cover-yanyue&orientation=portrait",
  },
];

export const monthlyHot: ComicItem[] = [
  {
    id: "mh-1",
    title: "燃魂少年团",
    author: "烈火",
    genre: "热血战斗",
    tags: ["竞技", "团队", "燃"],
    rating: "9.1",
    summary:
      "不被看好的杂牌队伍，决定在最高级别的联盟联赛里证明自己。最后一球落下前，谁都不准认输。",
    note: "本月讨论度断层第一，燃到发烫。",
    cover: "https://readdy.ai/api/search-image?query=High%20energy%20anime%20comic%20cover%20of%20a%20group%20of%20fierce%20teenage%20athletes%20in%20flames%20and%20motion%20on%20a%20stadium%20field%2C%20dynamic%20action%20pose%2C%20explosive%20warm%20orange%20and%20crimson%20tones%2C%20sports%20shonen%20manga%20style%2C%20high%20energy%20lighting&width=480&height=640&seq=cover-ranhun&orientation=portrait",
  },
  {
    id: "mh-2",
    title: "墨色江湖",
    author: "孤舟",
    genre: "武侠",
    tags: ["江湖", "权谋", "刀客"],
    rating: "9.0",
    summary:
      "墨色染尽的江湖里，无名刀客背负旧债踏入风雨。刀光与棋局交错，谁的执念最终改写这片江湖。",
    note: "打斗分镜行云流水，江湖气十足，本周热荐头牌。",
    cover: "https://readdy.ai/api/search-image?query=Ink%20wash%20anime%20comic%20cover%20of%20a%20lone%20swordsman%20in%20flowing%20robes%20on%20a%20misty%20mountain%20with%20falling%20petals%20and%20a%20blade%20in%20hand%2C%20dark%20ink%20and%20crimson%20accents%2C%20wuxia%20martial%20arts%20manga%20style%2C%20dramatic%20moody%20lighting&width=480&height=640&seq=cover-mojing&orientation=portrait",
  },
  {
    id: "mh-3",
    title: "时间修理店",
    author: "指针",
    genre: "奇幻悬疑",
    tags: ["时间", "因果", "反转"],
    rating: "8.9",
    summary:
      "只修故障时钟的老铺，实则修理的是人们错乱的命运。可每一次修复，都会在别处撕开新的裂口。",
    note: "设定精巧、结局全抖开，本月最让人头皮发麻的构思。",
    cover: "https://readdy.ai/api/search-image?query=Intricate%20anime%20comic%20cover%20of%20an%20old%20clockmakers%20shop%20with%20floating%20gears%20and%20spinning%20clock%20faces%20in%20an%20hourglass%20shaped%20glow%2C%20suspenseful%20mysterious%20atmosphere%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20detailed%20fantasy%20illustration&width=480&height=640&seq=cover-shijian&orientation=portrait",
  },
  {
    id: "mh-4",
    title: "荒野邮路",
    author: "苍原",
    genre: "公路冒险",
    tags: ["沙漠", "伙伴", "自由"],
    rating: "8.8",
    summary:
      "横穿荒野的最后一班邮车，载着一名邮差、一位迷路的歌手，和一头不肯配合的倔骡，一路向前。",
    note: "自由又洒脱，看完想立刻收拾行囊出发。",
    cover: "https://readdy.ai/api/search-image?query=Wide%20open%20anime%20comic%20cover%20of%20a%20lone%20mail%20stagecoach%20crossing%20a%20golden%20desert%20at%20sunset%20with%20long%20shadows%20and%20distant%20mesas%2C%20wanderer%20on%20top%2C%20free%20adventurous%20mood%2C%20warm%20amber%20and%20terracotta%20tones%2C%20clean%20cinematic%20composition&width=480&height=640&seq=cover-huanye&orientation=portrait",
  },
];

export const privateCollection: ComicItem[] = [
  {
    id: "pc-1",
    title: "旧城书店",
    author: "拾光",
    genre: "温情日常",
    tags: ["书店", "旧物", "治愈"],
    rating: "9.0",
    summary:
      "只在黄昏营业的旧城书店，店里每一本旧书，都藏着一个等待被重新翻开的故事。",
    note: "编辑私藏榜第一名，是翻烂了也会反复重读的压箱底。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20comic%20cover%20of%20a%20warm%20old%20town%20bookstore%20with%20stacked%20used%20books%20and%20a%20reading%20lamp%20glowing%20in%20golden%20dusk%20light%2C%20shelves%20filled%20with%20worn%20spines%2C%20nostalgic%20and%20heartwarming%20mood%2C%20warm%20amber%20and%20cream%20tones%2C%20cozy%20illustration&width=480&height=640&seq=cover-jiucheng&orientation=portrait",
  },
  {
    id: "pc-2",
    title: "五月雨",
    author: "青鸟",
    genre: "文艺恋爱",
    tags: ["雨季", "青春", "克制"],
    rating: "8.8",
    summary:
      "五月连绵的雨里，两个习惯把喜欢藏起来的人，在无数次擦肩之后，终于等到了晴天。",
    note: "暧昧推拉写得炉火纯青，私藏里最想按头告白的一部。",
    cover: "https://readdy.ai/api/search-image?query=Soft%20anime%20comic%20cover%20of%20two%20shy%20students%20sharing%20one%20umbrella%20under%20gentle%20may%20rain%20beside%20a%20cherry%20tree%2C%20overcast%20romantic%20mood%2C%20blooming%20flowers%2C%20muted%20pink%20and%20warm%20cream%20tones%2C%20sweet%20and%20poetic%20style&width=480&height=640&seq=cover-wuyue&orientation=portrait",
  },
  {
    id: "pc-3",
    title: "无名的信",
    author: "邮差阿禾",
    genre: "奇幻温情",
    tags: ["信件", "思念", "重逢"],
    rating: "8.9",
    summary:
      "没有署名、也找不到寄件人的一封信，被时间反复投递。直到它终于抵达，那个最需要它的人手里。",
    note: "第一话就把我看哭，编辑部私藏不轻易拿出来分享的存在。",
    cover: "https://readdy.ai/api/search-image?query=Melancholy%20anime%20comic%20cover%20of%20a%20sealed%20aged%20letter%20floating%20in%20a%20soft%20dreamy%20sky%20with%20folded%20paper%20birds%20and%20warm%20golden%20light%2C%20lonely%20yet%20hopeful%20mood%2C%20paper%20textures%2C%20warm%20sepia%20and%20cream%20tones%2C%20delicate%20illustration&width=480&height=640&seq=cover-wuming&orientation=portrait",
  },
  {
    id: "pc-4",
    title: "春日列车",
    author: "南湾",
    genre: "成长治愈",
    tags: ["列车", "风景", "释怀"],
    rating: "8.7",
    summary:
      "开往春天的末班列车，每停一站，就有一位乘客带着心事下车。终点站前，少年也终于学会了释怀。",
    note: "适合在一个人的夜晚慢慢读，温柔得恰到好处。",
    cover: "https://readdy.ai/api/search-image?query=Peaceful%20anime%20comic%20cover%20of%20a%20spring%20train%20gliding%20through%20blooming%20pink%20cherry%20orchards%20and%20green%20hills%2C%20petals%20in%20the%20air%2C%20warm%20morning%20sunlight%2C%20hopeful%20and%20gentle%20mood%2C%20soft%20pink%20and%20warm%20cream%20tones%2C%20clean%20composition&width=480&height=640&seq=cover-chunri&orientation=portrait",
  },
];

export const categories = [
  { key: "all", label: "全部" },
  { key: "xianqing", label: "悬疑推理" },
  { key: "zhiyu", label: "治愈温情" },
  { key: "rexue", label: "热血冒险" },
  { key: "lianai", label: "恋爱日常" },
  { key: "huanxiang", label: "奇幻科幻" },
];